var map = {
	"./banner_cookie_1.svg": 646,
	"./banner_cookie_2.svg": 93,
	"./banner_cookie_3.svg": 548,
	"./bg_cookies.svg": 858,
	"./close_icon.svg": 795,
	"./cookie.svg": 369,
	"./down_arrow.svg": 573,
	"./less_icon.svg": 692,
	"./locker_icon.svg": 101,
	"./plus_icon.svg": 333,
	"./site_icon.svg": 810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 234;